import { Routes } from '@angular/router';

import { ERoutes } from '../../types/app-routes';
import { CardCanDeactivateGuard } from '../../services/card-can-deactivate-guard.service';

export const awardsRoutes: Routes = [
  {
    path: ERoutes.AWARDS,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./awards-table/awards-table.component').then((m) => m.AwardsTableComponent),
      },
      {
        path: 'card',
        canDeactivate: [CardCanDeactivateGuard],
        loadComponent: () =>
          import('./awards-card/awards-card.component').then((m) => m.AwardsCardComponent),
      },
    ],
  },
];
